import dayjs, { type Dayjs } from 'dayjs';
import { RegionalOverviewFilterType, buildFilter, type Filter } from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewV2Properties } from 'querys/regional-overview/regional-overview.query.models';

const parseRange = (value: unknown): [Dayjs, Dayjs] | undefined => {
  if (!Array.isArray(value) || value.length !== 2) return undefined;
  const [begin, end] = value as [Dayjs, Dayjs];
  if (!begin || !end) return undefined;
  return [begin.startOf('day'), end.endOf('day')];
};

export const buildSowingDateFilter = <P extends RegionalOverviewV2Properties>(): Filter =>
  buildFilter<P>({
    type: RegionalOverviewFilterType.SOWING_DATE,
    translatable: false,
    freeform: true,
    getValues: () => [],
    matches: (feature, value) => {
      const range = parseRange(value);
      if (!range) return true;
      const planting = feature.properties?.values?.planting_date;
      if (!planting) return false;
      const plantingDate = dayjs(planting);
      const [begin, end] = range;
      return (plantingDate.isAfter(begin) || plantingDate.isSame(begin)) && (plantingDate.isBefore(end) || plantingDate.isSame(end));
    }
  });
